import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Dropdown from "../../components/Dropdown";
import RadarChart from "./RadarChart";
import GlobalRankingService from "../../services/globalRanking.service";
import PerformanceService from "../../services/performance.service";
import Toaster from "../../components/toaster";
import Loader from "../../assets/images/icons/loader.gif";
import { getPeriodOptions } from "../../periodOptions";

const BestCountry = () => {
  const createdAt = useSelector((state) => state.user.user?.createdAt);
  const [selectedOption, setSelectedOption] = useState("Select Game");
  const [selectedOption1, setSelectedOption1] = useState("This Year");
  const [selectedOption2, setSelectedOption2] = useState("score");
  const [data, setData] = useState([]);
  const [gameOptions, setGameOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const handleOptionSelect = (option) => {
    setSelectedOption(option.label);
  };

  const handleOptionSelect1 = (option1) => {
    setSelectedOption1(option1.label);
  };

  const handleOptionSelect2 = (option2) => {
    setSelectedOption2(option2.value);
  };

  const options = gameOptions;

  const options1 = getPeriodOptions(createdAt);

  const options2 = [
    { label: "Total Score", value: "score" },
    { label: "Hits", value: "hits" },
    { label: "Accuracy", value: "passing" },
  ];

  const getGlobalRanking = async () => {
    setIsLoading(true);
    try {
      if (
        selectedOption !== "Select Game" &&
        selectedOption1 !== "Select Period" &&
        selectedOption2 !== "Select Score"
      ) {
        const response = await GlobalRankingService.getGlobalRanking(
          selectedOption !== "Select Game" ? selectedOption : "",
          selectedOption1 !== "Select Period" ? selectedOption1 : "",
          selectedOption2 !== "Select Score" ? selectedOption2 : "",
          "bestCountry"
        );
        setData(response.data.data);
      }
    } catch (error) {
      Toaster("error", error.message);
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getGames = async () => {
    setIsLoading(true);
    try {
      const response = await PerformanceService.getGames();
      const gameData = [
        ...(response.data.data || []).map((item) => ({
          value: item.gameName,
          label: item.gameName,
        })),
      ];

      setGameOptions(gameData);
      setSelectedOption(gameData[0]?.label || "Select Game");
      setSelectedOption1(options1[3]?.label);
      setSelectedOption2(options2[0]?.value);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getGames();
  }, []);

  useEffect(() => {
    getGlobalRanking();
  }, [selectedOption, selectedOption1, selectedOption2]);

  return (
    <>
      {isLoading ? (
        <div className="flex justify-center mt-5">
          <img src={Loader} alt="Loader" className="w-16 h-16" />
        </div>
      ) : (
        <>
          {data?.length < 1 ? (
            <div>
              <p className="text-center text-white py-12">Data Not Found</p>
            </div>
          ) : (
            <>
              <div className="grid lg:grid-cols-4">
                <div className="col-span-2">
                  {data?.length > 0 && (
                    <RadarChart data={data} selectedOption2={selectedOption2} />
                  )}
                </div>
                <div className="overflow-hidden col-span-2">
                  <div className="overflow-auto max-h-[400px] table-main h-fit rounded-lg">
                    <table>
                      <thead>
                        <tr>
                          <th>Rank</th>
                          <th>Country</th>
                          <th>Player</th>
                          <th>
                            {selectedOption2 === "score"
                              ? "Score"
                              : selectedOption2 === "hits"
                              ? "Hits"
                              : "Passing"}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.country}</td>
                            <td>{item.isYou ? " You" : item.playername}</td>
                            <td>
                              {selectedOption2 === "score"
                                ? item.score
                                : selectedOption2 === "hits"
                                ? item.hits
                                : item.passing}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}

      <div className="grid tab:flex items-center justify-center gap-4 mt-5">
        <Dropdown
          label={selectedOption}
          options={options}
          onSelect={handleOptionSelect}
        />
        <Dropdown
          label={selectedOption1}
          options={options1}
          onSelect={handleOptionSelect1}
        />
        <Dropdown
          label={selectedOption2}
          options={options2}
          onSelect={handleOptionSelect2}
        />
      </div>
    </>
  );
};

export default BestCountry;
